export default class BlockKeyNumbers {
	static init() {

		let blocks = document.querySelectorAll('.block-key-numbers');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper-key-numbers');
			const prev = block.querySelector(".swiper-key-numbers-button-prev");
			const next = block.querySelector(".swiper-key-numbers-button-next");
			const pagination = block.querySelector('.swiper-key-numbers-pagination');

			new Swiper(swiper, {
				slidesPerView: 1,
				// centerInsufficientSlides: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
					enabled: true,
				},
				pagination: {
					el: pagination,
					type: 'bullets',
					enabled: true,
				},
				grabCursor: true,

				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 640px
					768: {
						grabCursor: false,
						slidesPerView: 4,
						navigation: {
							enabled: false,
						},
						pagination: {
							enabled: false,
						},
					},
					576: {
						slidesPerView: 2,
					},
				},
			});
		});
	}
}
